import { UserAccountInformativeBannerSection } from 'app/src/features/UserAccount/components/UserAccountInformativeBannerSection'
import { UserAccountOrderListSection } from 'app/src/features/UserAccount/components/UserAccountOrderListSection'
import { UserAccountPrizeListSection } from 'app/src/features/UserAccount/components/UserAccountPrizeListSection'
import { WalletOverviewSection } from 'app/src/features/UserAccount/components/WalletOverviewSection'
import { pageconfigurationsApi, type StatusConfigType } from 'app/src/services/welfareportal'
import { DynamicPageWidget } from 'app/src/shared/components'
import { useTranslation, useWebAppContext } from 'app/src/shared/hooks'
import { useEffect, useState, type ReactElement } from 'react'

export function ComponentRenderer(sections?: pageconfigurationsApi.SectionItem[]): ReactElement {
  const context = useWebAppContext()
  const { t: tShopping } = useTranslation('shopping', { keyPrefix: 'Direct' })
  const { t: tRefund } = useTranslation('shopping', { keyPrefix: 'Refund' })
  const { t: tMoneyTransfer } = useTranslation('shopping', { keyPrefix: 'Transfer' })

  const [directStatusList, setDirectStatusList] = useState<StatusConfigType[]>([])
  const [refundStatusList, setRefundStatusList] = useState<StatusConfigType[]>([])
  const [moneyTransferStatusList, setMoneyTransferStatusList] = useState<StatusConfigType[]>([])
  const [discountStatusList, setDiscountStatusList] = useState<StatusConfigType[]>([])

  useEffect(() => {
    const tDirectStatusList = []
    const directStateMapping = tShopping('StateMapping')
    for (const stateKey in directStateMapping) {
      tDirectStatusList.push({ key: stateKey, label: directStateMapping[stateKey].label })
    }
    setDirectStatusList(tDirectStatusList)

    const tRefundStatusList = []
    const refundStateMapping = tRefund('StateMapping')
    for (const stateKey in refundStateMapping) {
      tRefundStatusList.push({ key: stateKey, label: refundStateMapping[stateKey].label })
    }
    setRefundStatusList(tRefundStatusList)

    const tMoneyTransferStatusList = []
    const moneyTransferStatusMapping = tMoneyTransfer('StateMapping')
    for (const stateKey in moneyTransferStatusMapping) {
      tMoneyTransferStatusList.push({ key: stateKey, label: moneyTransferStatusMapping[stateKey].label })
    }
    setMoneyTransferStatusList(tMoneyTransferStatusList)

    const tDiscountStatusList = []
    const discountStateMapping = tShopping('StateMapping')
    for (const stateKey in discountStateMapping) {
      tDiscountStatusList.push({ key: stateKey, label: discountStateMapping[stateKey].label })
    }
    setDiscountStatusList(tDiscountStatusList)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      {sections &&
        sections?.map((section) => {
          switch (section.sectionName) {
            case 'InformativeSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <UserAccountInformativeBannerSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'WalletOverviewSection':
              return context.userInfo?.welfareCampaign?.phase === 'fruition' ||
                context.userInfo?.welfareCampaign?.phase === 'closed' ? (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <WalletOverviewSection {...props} />}
                  sectionItem={section}
                />
              ) : (
                <></>
              )
            case 'PrizeSection':
              return (
                context.userInfo?.welfareCampaign?.configuration?.funnels?.find((el) => el === 'PRIZE') && (
                  <DynamicPageWidget
                    key={section.sectionName}
                    componentRenderer={(props) => <UserAccountPrizeListSection {...props} directStatusList={directStatusList} />}
                    sectionItem={section}
                  />
                )
              )
            case 'OrderListSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => (
                    <UserAccountOrderListSection
                      {...props}
                      directStatusList={directStatusList}
                      refundStatusList={refundStatusList}
                      moneyTransferStatusList={moneyTransferStatusList}
                      discountStatusList={discountStatusList}
                    />
                  )}
                  sectionItem={section}
                />
              )

            default:
              if (section?.renderingMode !== 'native') {
                return <DynamicPageWidget key={section.sectionName} sectionItem={section} />
              } else {
                context.logger?.warn('Unknown Native Section', { section: section.sectionName })
                return <></>
              }
          }
        })}
    </>
  )
}
